import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ProtectedRoute from './components/protectedroute';
import { UserProvider } from './lib/usercontext';
import routes from './routes';
import useTokenRefresh from './hooks/usetokenrefresh';

const RouteWatcher = () => {
  useTokenRefresh();
  useLocation();
  return null;
};

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <UserProvider value={{ isLoggedIn, setIsLoggedIn }}>
      <Router>
        <RouteWatcher />
        <Routes>
          {routes.map((route, index) => {
            const RouteComponent = route.protected ?
              <ProtectedRoute allowedRoles={route.allowedRoles}>
                <route.element />
              </ProtectedRoute> : <route.element />;

            return <Route key={index} path={route.path} element={RouteComponent} />;
          })}
        </Routes>
      </Router>
    </UserProvider>
  );
}